import React, { Component } from 'react';
import { Form, Button, message, Input, Select } from 'antd';
import { connect } from 'react-redux';
import { SetupAction } from '../../actions';
import { bindActionCreators } from 'redux';
import { FormWrapper } from './style';
import { previewFile } from '../../common/utils';
import { uploadImage, putExchange } from '../../common/fetch';
import { EXCHANGE_S3_IMAGE } from '../../config/constants';
import { GLOBAL_LANGUAGE } from '../../config/media';
import { minimalTimezoneSet } from 'compact-timezone-list';
import Country from 'country-data';

minimalTimezoneSet.splice(15, 0, {
	label: '(GMT+03:30) Tehran',
	offset: '+03:30',
	tzCode: 'Asia/Iran',
});

const { Item } = Form;
const { TextArea } = Input;

class Step2 extends Component {
	state = {
		LOGO_IMAGE_LIGHT: '/assets/img/exchange-logo-light.svg',
		LOGO_IMAGE_LIGHT_ALT: 'exchange-logo-light.svg',
		LOGO_IMAGE_LIGHT_LOADING: false,
		LOGO_IMAGE_DARK: '/assets/img/exchange-logo-dark.svg',
		LOGO_IMAGE_DARK_ALT: 'exchange-logo-dark.svg',
		LOGO_IMAGE_DARK_LOADING: false,
		isDisabled: false,
		display_content: '0',
		button_top:'-40px',

	};

	componentDidMount() {
		const { state } = this.props;
		const { setFieldsValue } = this.props.form;
		const [FIRST_OPERATOR_NAME,LAST_OPERATOR_NAME] = state.OPERATOR_NAME && state.OPERATOR_NAME.split(' ')
		setFieldsValue({
			COMPANY_NAME: state.COMPANY_NAME,
			FIRST_OPERATOR_NAME : FIRST_OPERATOR_NAME,
			LAST_OPERATOR_NAME: LAST_OPERATOR_NAME,
			SUMMARY: state.SUMMARY,
			DEFAULT_COUNTRY:state.DEFAULT_COUNTRY
			// TIME_ZONE: biz.TIME_ZONE,
			// LANGUAGE: biz.LANGUAGE,
		});
		this.setState({
			LOGO_IMAGE_LIGHT: state.LOGO_IMAGE_LIGHT,
			LOGO_IMAGE_LIGHT_ALT: state.LOGO_IMAGE_LIGHT,
			LOGO_IMAGE_DARK: state.LOGO_IMAGE_DARK,
			LOGO_IMAGE_DARK_ALT: state.LOGO_IMAGE_DARK,
		});
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.state.display_content === '0') {
			setTimeout(() => {
				this.setState({ button_top:"0px" });
			}, 1300);
			setTimeout(() => {
				this.setState({ display_content: "1"});
			}, 1500);
		}
	}

	handleSubmit = async (e) => {
		this.setState({ isDisabled: true });
		e.preventDefault();
		const { actions, state } = this.props;
		const { getFieldValue } = this.props.form;
		const body = { ...this.state };
		body.DEFAULT_COLOR = getFieldValue('DEFAULT_COLOR');
		body.COMPANY_NAME = getFieldValue('COMPANY_NAME');
		body.OPERATOR_NAME = `${getFieldValue('FIRST_OPERATOR_NAME')} ${getFieldValue('LAST_OPERATOR_NAME')}`
		body.SUMMARY = getFieldValue('SUMMARY');
		body.DEFAULT_COUNTRY = getFieldValue('DEFAULT_COUNTRY');
		body.LOGO_IMAGE = this.state.LOGO_IMAGE_LIGHT;
		actions.updateBiz(body);
		try {
			const exchangeBody = {
				id: state.id,
				info: {
					biz: { ...body },
					is_temp: state.is_temp,
				},
			};
			delete exchangeBody.info.biz.id;
			await putExchange(exchangeBody);
			this.props.onOk();
			this.setState({ isDisabled: false });
		} catch (error) {
			console.error(error);
			message.error('Failed to update setup configs');
			this.setState({ isDisabled: false });
		}
	};

	handleChangeFile = (e) => {
		const { files, name } = e.target;
		const { state } = this.props;
		this.setState(
			{
				[`${name}_LOADING`]: true,
			},
			async () => {
				try {
					const formData = new FormData();
					const file_name = name;
					formData.append('exchange_name', state.EXCHANGE_NAME);
					formData.append('file_name', file_name);
					formData.append('file', files[0]);

					await uploadImage(formData);
				} catch (error) {
					this.setState({
						[name + '_LOADING']: false,
					});
					message.error(
						'Failed to upload your image. Please try again.'
					);
					return;
				}
				try {
					await previewFile(files[0]);
					this.setState({
						[name + '_LOADING']: false,
						[name + '_ALT']: EXCHANGE_S3_IMAGE(name, state.EXCHANGE_NAME),
						[name]: EXCHANGE_S3_IMAGE(name, state.EXCHANGE_NAME),
					});
				} catch (error) {
					this.setState({
						[name + '_LOADING']: false,
					});
					console.error(error);
					message.error('Failed to upload the logo');
				}
			}
		);
	};

	renderCountries = () => {
		const country = Country.countries.all
			.filter((item) => {
				return item.status === 'assigned';
			})
			.sort((a, b) => {
				const nameA = a.name.toUpperCase(),
					nameB = b.name.toUpperCase();
				if (nameA < nameB) {
					return -1;
				}
				if (nameA > nameB) {
					return 1;
				}
				return 0;
			});
		return country.map((item) => {
			return (
				<Select.Option key={item.alpha2}>
					<span className={`flag-icon flag-icon-${item.alpha2.toLowerCase()} icon`} /> {item.name}
				</Select.Option>
			);
		});
	};

	render() {
		const {
			// LOGO_IMAGE_LIGHT,
			// LOGO_IMAGE_DARK,
			LOGO_IMAGE_LIGHT_LOADING,
			LOGO_IMAGE_DARK_LOADING,
			isDisabled,
			button_top
		} = this.state;
		const { getFieldDecorator } = this.props.form;
		return (
			<FormWrapper>
				<Form onSubmit={this.handleSubmit} className="branding-form"  >
					<Item className='item-container' style={{marginTop:'24px'}}>
						<h3 className="form-label">Company Name</h3>
						<p>
							What is the company name or official business that will be running this platform.
						</p>
						{getFieldDecorator('COMPANY_NAME')(
						<Input placeholder="Company Name" />
						)}
					</Item>
					<Item className='item-container'>
						<h3 className="form-label">Summary of platform</h3>
						<p>
							Add a description for the platform. This can be the platform's unique selling point, the target market and other business related information.
						</p>
						{getFieldDecorator('SUMMARY')(
						<TextArea style={{ height: 80}} placeholder="Write a brief summary of the business" />
						)}
					</Item>
					<Item>
						<h3 className="form-label">Country</h3>
						<p>
						This will be your exchanges primary location to promote and operate your exchange from. In the case of global crypto exchanges please pick global.
						</p>
						{getFieldDecorator('DEFAULT_COUNTRY')(
							<Select placeholder='Select location'>
								<Select.Option value="" >
									<div className="global-menu">
										<img src={GLOBAL_LANGUAGE} className="mini-icon" alt="global-menu" />
										Global
									</div>
								</Select.Option>
								{this.renderCountries()}
							</Select>
						)}
					</Item>
					<div className='smooth-drop'>
						<div className='animation-bounce'>
							<div className='align-center'>
								<div className='details-container' style={{ opacity: this.state.display_content }}>
									<div className='info-icon'>i</div>
									<div>Note: <span>All details can be changed at a later date</span></div>
								</div>
							</div>
						<Button
						block
						type="primary"
						htmlType="submit"
						style={{top:button_top}}
						disabled={(LOGO_IMAGE_LIGHT_LOADING && LOGO_IMAGE_DARK_LOADING) || isDisabled}
					>
						Next
					</Button>
						</div>
					</div>
				</Form>
			</FormWrapper>
		);
	}
}

const Branding = Form.create()(Step2);

const mapStateToProps = (state) => {
	return {
		state: state.setup.biz,
	};
};

const mapDispatchToProps = (dispatch) => ({
	actions: bindActionCreators(SetupAction, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Branding);
